import api from './api';

// ==================== TYPES ====================

export interface ArticleCategory {
  _id: string;
  name: string;
  slug: string;
  description?: string;
  icon?: string;
  parentId?: string | null;
  parent?: {
    _id: string;
    name: string;
    slug: string;
  } | null;
  children?: ArticleCategory[];
  order: number;
  isActive: boolean;
  articleCount: number;
  level?: number;
  createdAt: string;
  updatedAt: string;
}

export interface CategoryFormData {
  name: string;
  description?: string;
  icon?: string;
  parentId?: string | null;
  order?: number;
  isActive?: boolean;
}

// ==================== API METHODS ====================

/**
 * دریافت لیست دسته‌بندی‌ها
 */
export const getCategories = async (activeOnly?: boolean): Promise<ArticleCategory[]> => {
  const params: Record<string, any> = {};
  if (activeOnly !== undefined) params.activeOnly = activeOnly;

  const response = await api.get('/admin/articles/categories', { params }) as any;
  return response?.data || response;
};

/**
 * ایجاد دسته‌بندی جدید
 */
export const createCategory = async (data: CategoryFormData): Promise<ArticleCategory> => {
  const response = await api.post('/admin/articles/categories', data) as any;
  return response?.data || response;
};

/**
 * ویرایش دسته‌بندی
 */
export const updateCategory = async (id: string, data: CategoryFormData): Promise<ArticleCategory> => {
  const response = await api.put(`/admin/articles/categories/${id}`, data) as any;
  return response?.data || response;
};

/**
 * حذف دسته‌بندی
 */
export const deleteCategory = async (id: string): Promise<void> => {
  await api.delete(`/admin/articles/categories/${id}`);
};
